"use strict"
exports.__esModule = true;
exports.DirectionsIconConfig = {
  name: 'DirectionsIcon',
  height: 512,
  width: 512,
  svgPath: 'M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z',
  yOffset: 0,
  xOffset: 0,
};
exports.DirectionsIcon = require('../createIcon').createIcon(exports.DirectionsIconConfig);
exports["default"] = exports.DirectionsIcon;